import { GeneratableSelectInputOptions } from 'shared-ui/lib/components/customs/form/SelectInput';
import { sharedTranslations } from 'shared-ui/lib/shared-translations';

const serviceEventTypes = [
  'ALCOLOCK',
  'FRONT_BREAK',
  'AIR_FILTER',
  'TIMING_BELT',
  'GAS_EQUIPMENTS',
  'INSPECTION',
  'SUMMER_TIRE',
  'SPEED_LIMITER',
  'TACHOGRAPH',
  'FUEL_FILTER',
  'EXTINGUISHER',
  'REAR_BREAK',
  'TAXIMETER',
  'WINTER_TIRE',
  'LIGHTS',
  'OIL',
  'PERIODIC_MAINTENANCE',
  'OTHER',
];

const fixedOrder: Record<string, number> = {
  PERIODIC_MAINTENANCE: 0,
  OTHER: 1,
};
const fiLabelsByType = (sharedTranslations.fi?.ServiceEventType || {}) as Record<string, string>;

const sortServiceEventTypes = (types: string[]) =>
  [...types].sort((a, b) => {
    const aPriority = fixedOrder[a] ?? Number.MAX_SAFE_INTEGER;
    const bPriority = fixedOrder[b] ?? Number.MAX_SAFE_INTEGER;

    if (aPriority !== bPriority) return aPriority - bPriority;

    const aLabel = fiLabelsByType[a] ?? a;
    const bLabel = fiLabelsByType[b] ?? b;

    return aLabel.localeCompare(bLabel, 'fi');
  });

export const getServiceEventTypeOptions = (): GeneratableSelectInputOptions['props']['options'] => {
  const options = sortServiceEventTypes(serviceEventTypes).map((value) => ({
    value,
    label: `ServiceEventType:${value}`,
  }));

  return options;
};
